var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.72656 0.5C6.96094 0.5 7.14844 0.640625 7.24219 0.828125L8.85938 4.13281L12.4453 4.67188C12.6562 4.69531 12.8203 4.85938 12.8906 5.04688C12.9609 5.25781 12.9141 5.46875 12.75 5.63281L10.1484 8.21094L10.7578 11.8438C10.8047 12.0547 10.7109 12.2891 10.5469 12.4062C10.3594 12.5234 10.125 12.5469 9.9375 12.4531L6.72656 10.7188L3.51562 12.4531C3.32812 12.5469 3.11719 12.5234 2.92969 12.4062C2.76562 12.2891 2.67188 12.0547 2.69531 11.8438L3.32812 8.21094L0.726562 5.63281C0.5625 5.46875 0.515625 5.25781 0.585938 5.04688C0.65625 4.85938 0.820312 4.69531 1.03125 4.67188L4.61719 4.13281L6.23438 0.828125C6.32812 0.640625 6.51562 0.5 6.72656 0.5ZM6.72656 2.35156L5.50781 4.90625C5.41406 5.07031 5.27344 5.1875 5.08594 5.21094L2.29688 5.60938L4.3125 7.60156C4.45312 7.74219 4.5 7.92969 4.47656 8.11719L4.00781 10.9062L6.46875 9.59375C6.63281 9.5 6.84375 9.5 7.00781 9.59375L9.46875 10.9062L9 8.11719C8.95312 7.92969 9.02344 7.74219 9.16406 7.60156L11.1562 5.60938L8.39062 5.21094C8.20312 5.1875 8.03906 5.07031 7.96875 4.90625L6.72656 2.35156Z",
    fill: "#1D2132"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.1c00a5a0b36c1b4fc11dac5fa2775be6.svg";
export { ForwardRef as ReactComponent };